module.exports = __webpack_public_path__ + "img/video-solid.fb4c3aa3.svg";